import { forwardRef } from 'react'

import { Menu, MenuItem } from '@/components/interactives/dropdown-menu'
import { faGear } from '@fortawesome/free-solid-svg-icons'

import { cn } from '@/utils'

import { CueType } from '~shared/rundown/cue'
import type { Cue } from '~shared/rundown/cue'

import { useOptimisticCueSettings } from './menu.hooks'
import type { SettingsState, UpdateCueCallback } from './menu.types'

const settingsConfig = [
  { key: 'skipDuringShow' as keyof SettingsState, label: 'Skip during show' },
  { key: 'hideOnPdf' as keyof SettingsState, label: 'Hide on PDF export' },
  { key: 'hideOnCsv' as keyof SettingsState, label: 'Hide on CSV export' },
  { key: 'preventEdits' as keyof SettingsState, label: 'Prevent edits' },
] as const

type CueSettingsSubmenuProps = {
  cue: Cue
  onUpdateCue: UpdateCueCallback
}

export const CueSettingsSubmenu = forwardRef<
  HTMLButtonElement,
  CueSettingsSubmenuProps
>(function CueSettingsSubmenu({ cue, onUpdateCue }, ref) {
  const { optimisticSettings, toggleSetting } = useOptimisticCueSettings(
    cue?.settings,
    onUpdateCue,
  )

  return (
    <Menu
      ref={ref}
      icon={faGear}
      label="Settings"
      className={cn(
        cue.type === CueType.HEADING &&
          'bg-black opacity-40 pointer-events-none',
      )}
    >
      {settingsConfig.map(({ key, label }) => (
        <MenuItem
          key={key}
          IconComponent={
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={optimisticSettings?.[key]}
                readOnly
              />
            </div>
          }
          label={label}
          onClick={() => toggleSetting(key)}
        />
      ))}
    </Menu>
  )
})
